import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { funnelInputCharsetProperty } from './funnel-input-charset';

export const KIOSKCARTFUNNELINPUTTEXTBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "placeholder",
  "input_charset",
  "required",
  { type: 'separator' },
  "text_color",
  "color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelInputTextBlockDescriptor: _generatedKioskCartFunnelInputTextBlockDescriptor,
  kioskCartFunnelInputTextBlockBlocDefinition,
  kioskCartFunnelInputTextBlockDashboardLayout,
  kioskCartFunnelInputTextBlockConfig,
  kioskCartFunnelInputTextBlockResolveConfig,
  kioskCartFunnelInputTextBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Text input",
    componentType: 'KioskCartFunnelInputTextBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Text input.",
    keywords: [],
    allowedIn: [
      { bloc: "KioskCartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.title.label",
        help: "pages.blocks.kiosk-cart-funnel-input-text.title.help",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.placeholder.label",
      }
    }),
    input_charset: funnelInputCharsetProperty("kiosk-cart-funnel-input-text"),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.required.label",
      }
    }),
    display_custom_title_in_comment: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.display-custom-title-in-comment.label",
      }
    }),
    custom_title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.custom-title.label",
        help: "pages.blocks.kiosk-cart-funnel-input-text.custom-title.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.text-color.label",
      }
    }),
    color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-input-text.color.label",
      }
    })
  }),

  () => ({
    omitFields: ["display_custom_title_in_comment", "custom_title"] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-input-text.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-input-text.fieldset.field.label",
            fields: [
              "title",
              "placeholder",
              "input_charset",
              "required",
              "text_color",
              "color",
            ],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelInputTextBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelInputTextBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelInputTextBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelInputTextBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelInputTextBlockDescriptor, kioskCartFunnelInputTextBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelInputTextBlockBlocDefinition,
  kioskCartFunnelInputTextBlockDashboardLayout,
  kioskCartFunnelInputTextBlockProperties,
  kioskCartFunnelInputTextBlockConfig,
  kioskCartFunnelInputTextBlockResolveConfig,
};

export type KioskCartFunnelInputTextBlockConfig = typeof kioskCartFunnelInputTextBlockConfig;
